import { useCallback } from 'react';

import { MOTStatus, TaxStatus } from '../@types/motCheck';
import {
  CHECK_TOOLS_CATEGORIES_LIST,
  CHECKER_TOOLS_EVENTS,
  CHECKER_TOOLS_PAGE_SECTIONS,
} from '../Pages/CheckerRouter.utils';

import { useGetRouteAndPageName } from './useGetRouteAndPageName';

export const useCheckerToolsAnalytics = () => {
  const { routeInfo } = useGetRouteAndPageName();

  const checkerPage = routeInfo?.checkerPage;
  const resultsSuffix = routeInfo?.isResultsPage ? 'Results' : '';
  const categoryKey = CHECK_TOOLS_CATEGORIES_LIST[`${checkerPage}${resultsSuffix}` as keyof typeof CHECK_TOOLS_CATEGORIES_LIST];

  const triggerSectionLoadEvent = useCallback((
    name: typeof CHECKER_TOOLS_PAGE_SECTIONS[keyof typeof CHECKER_TOOLS_PAGE_SECTIONS],
    label?: string,
    checkerStatus?: MOTStatus | TaxStatus,
  ) => {
    CHECKER_TOOLS_EVENTS.SECTION_LOADED({
      category: checkerStatus ? `${categoryKey}_${checkerStatus.toLowerCase()}` : categoryKey,
      label,
      name,
    });
  }, [categoryKey]);
  const triggerPopupLoadEvent = useCallback(({
    checkerStatus,
    label,
    name,
  }:{
    checkerStatus?: MOTStatus | TaxStatus;
    label?: string;
    name: typeof CHECKER_TOOLS_PAGE_SECTIONS[keyof typeof CHECKER_TOOLS_PAGE_SECTIONS] | string;
  }) => {
    CHECKER_TOOLS_EVENTS.POPUP_LOADED({
      category: checkerStatus ? `${categoryKey}_${checkerStatus.toLowerCase()}` : categoryKey,
      label,
      name,
    });
  }, [categoryKey]);

  const triggerClickEvent = useCallback(({
    buttonLabel,
    checkerStatus,
    label,
    name,
    url,
  }: {
    buttonLabel?: string;
    checkerStatus?: MOTStatus | TaxStatus;
    label: string;
    name: string;
    url?: string;
  }) => {
    CHECKER_TOOLS_EVENTS.CLICKED({
      category: checkerStatus ? `${categoryKey}_${checkerStatus.toLowerCase()}` : categoryKey,
      label,
      name,
      url,
      ...(buttonLabel && { button_label: buttonLabel }),
    });
  }, [categoryKey]);

  const triggerAnalyticsCtaClick = useCallback(({
    buttonLabel,
    checkerStatus,
    label,
    name,
    success,
    url,
  }: {
    buttonLabel: string;
    checkerStatus?: MOTStatus | TaxStatus;
    label?: string;
    name: typeof CHECKER_TOOLS_PAGE_SECTIONS[keyof typeof CHECKER_TOOLS_PAGE_SECTIONS] | string;
    success?: boolean;
    url: string;
  }) => {
    CHECKER_TOOLS_EVENTS.CTA_CLICKED({
      buttonLabel,
      category: checkerStatus ? `${categoryKey}_${checkerStatus.toLowerCase()}` : categoryKey,
      label,
      name,
      success,
      url,
    });
  }, [categoryKey]);

  return {
    triggerAnalyticsCtaClick,
    triggerClickEvent,
    triggerPopupLoadEvent,
    triggerSectionLoadEvent,
  };
};
